import { formatStrStationId } from "aegion_common_utilities/lib/format/numeric";
import { getSystemOfUnits } from "../../util/user";

const IS_IMPERIAL = getSystemOfUnits() === 'Imperial';

/* eslint-disable prefer-const */
export const formatStationId = (val, { includeUnit = false } = {}) => {
	const value = formatStrStationId(val, { unit: IS_IMPERIAL ? 'feet' : 'meters' });
	if (!includeUnit) {
		return value;
	}
	const unit = IS_IMPERIAL ? 'ft' : 'm';
	return `${value} ${unit}`;
};

export default { formatStationId };
